module.exports = __webpack_public_path__ + "img/icon-siwei-teacher-logo.095d5733.png";